
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 224 226"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","y1":"6.76%","x2":"50%","x1":"50%","y2":"95.6%"}},[_c('stop',{attrs:{"stop-color":"#00c6ff","offset":"0"}}),_c('stop',{attrs:{"stop-color":"#0068ff","offset":"1"}})])]),_c('path',{attrs:{"fill":"url(#a)","d":"M41.255 185.52v40.2l37.589-21.37C89.322 207.37 100.46 209 112 209c61.86 0 112-46.79 112-104.5S173.86 0 112 0 0 46.786 0 104.5c0 32.68 16.078 61.86 41.255 81.02z"}}),_c('path',{attrs:{"fill":"#fff","d":"M100.04 75.878L39.639 139.83l54.97-30.16 28.721 30.16 60.06-63.952-54.36 29.632-28.99-29.632z"}})])
          )
        }
      }
    